var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "43px",
    viewBox: "0 0 42 43",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BE24F8F1-49E6-4905-B328-8AC146D1C5BD") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 42,
    height: 42,
    rx: 10
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    transform: "translate(-937.000000, -1235.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logout",
    transform: "translate(937.000000, 1235.278198)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Team-photo"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ic_Plus",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.000000, 9.000000)",
    id: "iconspace_Group-20_25px"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,3 C14.9239103,3 16.5,4.39675 16.5,6.15 L16.5,7.75 C16.5,8.16421356 16.1642136,8.5 15.75,8.5 C15.3357864,8.5 15,8.16421356 15,7.75 L15,6.15 C15,5.25485775 14.1151662,4.5 13,4.5 L7.5,4.5 C6.3848338,4.5 5.5,5.25485775 5.5,6.15 L5.5,17.35 C5.5,18.2451422 6.3848338,19 7.5,19 L13,19 C14.1151662,19 15,18.2451422 15,17.35 L15,15.75 C15,14.75 16.5,14.75 16.5,15.75 L16.5,17.35 C16.5,19.10325 14.9239103,20.5 13,20.5 L7.5,20.5 C5.57608974,20.5 4,19.10325 4,17.35 L4,6.15 C4,4.39675 5.57608974,3 7.5,3 L13,3 Z M17.4838551,9.02321852 L19.4838551,11.050074 C19.7734175,11.3435246 19.7718431,11.8156726 19.4803302,12.1071856 L17.4803302,14.1071856 C17.1874369,14.4000788 16.7125632,14.4000788 16.41967,14.1071856 C16.1267768,13.8142924 16.1267768,13.3394187 16.41967,13.0465255 L16.9661954,12.5 L9.75,12.5 C9.33578644,12.5 9,12.1642136 9,11.75 C9,11.3357864 9.33578644,11 9.75,11 L17.3271309,11 L16.416145,10.0767816 C16.1252116,9.78194163 16.1283785,9.30707845 16.4232185,9.01614504 C16.7180585,8.72521162 17.1929217,8.72837852 17.4838551,9.02321852 Z",
    id: "Combined-Shape",
    fill: "#FC5A5A"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.b8affa435d2c46c03e9d3f6507440c76.svg";
export { ForwardRef as ReactComponent };